import { render, staticRenderFns } from "./BrandLogoTextboxTerraskola.vue?vue&type=template&id=965277f0&"
import script from "./BrandLogoTextboxTerraskola.vue?vue&type=script&lang=js&"
export * from "./BrandLogoTextboxTerraskola.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports